module.exports = __webpack_public_path__ + "img/initial-fetch-error-image.e92f3eb3.png";